import {
  loading,
  registerFailed,
  registerSuccess,
  loginFailed,
  loginSuccess,
  clearShoppingState,
  logoutFailed,
  logoutSuccess,
} from './loginActions'

import { getPartList } from '../parts/partThunks'
import { getOrdersList } from '../orders/orderThunks'
import { getCustomersList } from '../customers/customerThunks'

// Async action creators

export const register = (user) => {
  return async (dispatch) => {
    let request = {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-type': 'application/json' },
      body: JSON.stringify(user),
    }
    dispatch(loading())
    let response = await fetch('/api/registration', request)
    if (!response) {
      dispatch(
        registerFailed(
          'There was an error with the connection. Register failed!'
        )
      )
      return
    }
    if (response.ok) {
      dispatch(registerSuccess())
    } else {
      if (response.status === 409) {
        dispatch(registerFailed('Username already in use'))
      } else {
        dispatch(
          registerFailed(
            'Register failed. Server responded with a status ' + response.status
          )
        )
      }
    }
  }
}

export const logAction = (user) => {
  return async (dispatch) => {
    let request = {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-type': 'application/json' },
      body: JSON.stringify(user),
    }
    dispatch(loading())
    let response = await fetch('/api/login', request)
    if (!response) {
      dispatch(loginFailed('There was an error the connection. Login failed!'))
    }
    if (response.ok) {
      let data = await response.json()
      if (!data) {
        dispatch(loginFailed('Error parsing login information. Login failed!'))
      }
      dispatch(loginSuccess(data))
      dispatch(getPartList(data.token))
      dispatch(getOrdersList(data.token))
      dispatch(getCustomersList(data.token))
    } else {
      dispatch(
        loginFailed(
          'Login failed. Server responded with a status:' + response.status
        )
      )
    }
  }
}

export const logout = (token) => {
  return async (dispatch) => {
    let request = {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-type': 'application/json', token: token },
    }
    dispatch(loading())
    let response = await fetch('/api/logout', request)
    if (!response) {
      dispatch(
        logoutFailed('There was an error with the connection. Logging you out!')
      )
      dispatch(clearShoppingState())
      return
    }
    if (response.ok) {
      dispatch(logoutSuccess())
      dispatch(clearShoppingState())
    } else {
      dispatch(
        logoutFailed(
          'Server responded with a status ' +
            response.status +
            '. Logging you out!'
        )
      )
      dispatch(clearShoppingState())
    }
  }
}
